// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取用户推送订阅信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /notice-sub/filter */
export async function noticeSubFilterUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.noticeSubFilterUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListNoticeSubInfoResp>('/notice-sub/filter', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取推送订阅信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /notice-sub/me */
export async function noticeSubMeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.noticeSubMeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/notice-sub/me', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 设置推送订阅信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /notice-sub/set */
export async function noticeSubSetUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.noticeSubSetUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/notice-sub/set', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
